const prefix = 'cvf-admin/projectData/';

export const GET_PROJECT_DATA = `${prefix}GET_PROJECT_DATA`;
export const GET_PROJECT_DATA_SUCCESS = `${prefix}GET_PROJECT_DATA_SUCCESS`;
export const GET_PROJECT_DATA_ERROR = `${prefix}GET_PROJECT_DATA_ERROR`;
export const UPDATE_PROJECT_SESSION_DATA = `${prefix}UPDATE_PROJECT_SESSION_DATA`;
export const UPDATE_PROJECT_SESSION_DATA_ERROR = `${prefix}UPDATE_PROJECT_SESSION_DATA_ERROR`;
export const UPDATE_PROJECT_SESSION_DATA_SUCCESS = `${prefix}UPDATE_PROJECT_SESSION_DATA_SUCCESS`;
